import { module as BaseModule } from 'modujs'

export default class extends BaseModule {
  constructor(m) {
    super(m)

    this.events = {
      click: {
        background: 'goBack',
        button: 'goBack',
      },
    }
  }

  goBack() {
    window.history.back()
  }
}
